export class UpdateVideoCardBenchmarkRequest {

    VideoCardBenchmarkID: number;
    NewBenchmarkScore: number;

}